
import { getCurrentIntl } from '../i18n/intl/intl';

interface PriorityLevelProps {
  id: number;
  name: string;
}
const getStatusOptions = () => {
  const intl = getCurrentIntl();
  const statusOptions: Array<PriorityLevelProps> = [
    {
      id: 0,
      name: intl.formatMessage({ defaultMessage: 'New Report' }),
    },
    {
      id: 1,
      name: intl.formatMessage({ defaultMessage: 'Under Review' }),
    },
    {
      id: 2,
      name: intl.formatMessage({
        defaultMessage: 'Pending further information',
      }),
    },
    {
      id: 3,
      name: intl.formatMessage({ defaultMessage: 'Closed' }),
    },
    {
      id: 5,
      name: intl.formatMessage({
        defaultMessage: 'Closed - Reporter Initiated',
      }),
    },
    {
      id: 6,
      name: intl.formatMessage({ defaultMessage: 'Archived' }),
    },
  ];
  return statusOptions;
};

export default getStatusOptions;